import { createFileRoute } from '@tanstack/react-router';

import { CarrierExportsTab } from '../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <CarrierExportsTab annuityIntegrationId={params.annuityIntegrationId} />
  );
};

export const Route = createFileRoute('/carriers/$annuityIntegrationId/exports')(
  {
    component: Page
  }
);
